export default {
    edit: "Szerkesztés",
    location: "Lokáció + ÁSZF",
    filter: "Filter"
}
